import type {ReactElement} from 'react';
import {Snackbar} from '@Components/snackbar';
import {SnackbarMessageGrowl} from '@Components/snackbar-message-growl';
import {useInChatJobDismissWatcher} from '@Components/ai-chat-window/hooks/useInChatJobDismissWatcher';
import {usePublishDismissWatcher} from '@Components/ai-chat-window/hooks/usePublishDismissWatcher';

export function AiChatLoadingStates(): ReactElement {
  useInChatJobDismissWatcher();
  usePublishDismissWatcher();

  return (
    <div className={'_position-absolute _full-width _full-height'}>
      <Snackbar zIndex={5002} />
      <SnackbarMessageGrowl zIndex={5002} />
    </div>
  );
}
